<template>
    <div>
        <v-card
            outlined
            color="#E5D5CB"
        >
            <v-card-text>
                <v-form @submit="searchSubmit" target="hiddenframe">
                    <v-row>
                        <v-col cols="5">
                            <v-text-field
                                v-model="searchTerm"
                                label="Enter Search term here"
                                prepend-inner-icon="mdi-magnify-scan"
                                clearable
                                dense
                            ></v-text-field>
                        </v-col>
                        <v-col cols="3">
                            <v-btn
                                type="submit"
                                color="#BE977E"
                                :disabled="disable"
                                id="searchbtn"
                                :loading="searchloading"
                            >
                                <span style="color: white;">Search</span>
                            </v-btn>
                        </v-col>
                    </v-row>
                </v-form>
                <v-card>
                    <v-data-table
                        :headers="headers"
                        :items="students"
                        :loading="loading"
                        :loading-text="loadingMsg"
                    >
                        <template v-slot:top>
                            <v-dialog
                                v-model="dialog1"
                                fullscreen
                                hide-overlay
                                transition="dialog-bottom-transition"
                            >
                                <v-card elevation="0">
                                    <v-toolbar
                                        dark
                                        color="#3949AB"
                                    >
                                        <v-btn
                                            icon
                                            dark
                                            @click="closeStudentView()"
                                        >
                                            <v-icon>mdi-close</v-icon>
                                        </v-btn>
                                        <v-toolbar-title>View as {{selectedStudent.firstname+" "+selectedStudent.lastname+" ("+selectedStudent.emplid+")"}}</v-toolbar-title>
                                    </v-toolbar>
                                    <ViewAsStudent :student="selectedStudent" v-if="dialog1" />
                                </v-card>
                            </v-dialog>
                            <v-dialog
                                v-model="dialog2"
                                persistent
                                max-width="900"
                            >  
                                <v-card>
                                    <v-card-title class="text-h5">
                                        View Documents
                                    </v-card-title>
                                    <v-card-text>
                                        <ViewDocuments :student="selectedStudent" v-if="dialog2"/>
                                    </v-card-text>
                                    <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <v-btn
                                            color="green darken-1"
                                            text
                                            @click="dialog2 = false"
                                        >
                                            Close
                                        </v-btn>
                                    </v-card-actions>
                                </v-card>
                            </v-dialog>
                        </template>
                        <template v-slot:item.actions="{ item }">
                            <v-icon
                                small
                                @click="viewAsStudent(item)"
                            >
                                mdi-eye
                            </v-icon>
                            &nbsp;
                            <v-icon
                                small
                                @click="viewDocs(item)"
                            >
                                mdi-file-multiple
                            </v-icon>
                        </template>        
                    </v-data-table>
                </v-card>
            </v-card-text>
        </v-card>
        <v-snackbar
            v-model="snackbar"
            :color="snackbarcolor"
            :timeout="timeout"
        >
            {{ text }}
        </v-snackbar>
    </div>
</template>
<script>
import ViewAsStudent from "./ViewAsStudent.vue"
import ViewDocuments from "./ViewDocuments.vue"
export default {
    components: {
        ViewAsStudent,
        ViewDocuments
    },
    data(){
        return {
            host: location.hostname.toString(),
            loading: false,
            loadingMsg: "Calling search result...",
            searchTerm: "",
            headers: [
                {text: "Student Number", value: "emplid"},
                {text: "Email", value: "email"},
                {text: "Lastname", value: "lastname"},
                {text: "Firstname", value: "firstname"},
                {text: "Actions", value: "actions", sortable: false}
            ],
            students: [],
            snackbar: false,
            snackbarcolor: "",
            text: "",
            timeout: 3500,
            dialog1: false,
            selectedStudentIndex: -1,
            selectedStudent: {
                emplid: "",
                email: "",
                lastname: "",
                firstname: ""
            },
            dialog2: false,
            searchloading: false
        }
    },
    methods: {
        searchSubmit(){
            const that = this;

            that.searchloading = true;
            that.loading = true;

            let api = 'https://'+that.host+'/cgi-bin/sfs-portal-api/api.py?adminStudentSearch&data={ "term" : "'+that.searchTerm+'" }';

            fetch(api)
                .then(function (response) {
                    return response.json();
                })
                .then(function (resultData) {
                    if(!resultData.result.match(/OK/i)){
                        that.loading = false;
                        that.setSnackbar("Warning: "+resultData.message,"#FFCC80"); //Orange
                    }
                    //Returning Data set
                    if(resultData.data){
                        that.loading = false;
                        that.setSnackbar("Success: "+resultData.message,"#81C784"); //Green
                        
                        that.students = resultData.data;
                    }

                    that.searchloading = false;
                })
                .catch(function(err){
                    that.loading = false;
                    that.searchloading = false;
                    that.setSnackbar("Error occurred: "+err.toString(),"#E57373"); //light red
                });            
            //End of API calling

            that.searchTerm = "";
        },
        closeStudentView(){
            const that = this;
            sessionStorage.removeItem("sfs_asss");
            that.dialog1 = false;
        },
        viewAsStudent(item){
            const that = this;
            that.selectedStudentIndex = that.students.indexOf(item);
            that.selectedStudent = item;
            that.dialog1 = true;
        },
        viewDocs(item){
            const that = this;
            that.selectedStudentIndex = that.students.indexOf(item);
            that.selectedStudent = item;
            that.dialog2 = true;
        },
        setSnackbar(msg, color){ //Sets Snackbar
            const that = this;
            that.snackbar = true;
            that.snackbarcolor = color;
            that.text = msg;
        }
    }
}
</script>